import { render, staticRenderFns } from "./PortTradeflowsMap.vue?vue&type=template&id=b5f3ec30&scoped=true&"
import script from "./PortTradeflowsMap.vue?vue&type=script&lang=js&"
export * from "./PortTradeflowsMap.vue?vue&type=script&lang=js&"
import style0 from "./PortTradeflowsMap.vue?vue&type=style&index=0&id=b5f3ec30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f3ec30",
  null
  
)

export default component.exports